import APIClient from '@/shared/http/clients/api'

const resourceName = 'usuarios'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=username,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const UpdatePassword = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/password`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?name=${document}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
const GetAllFromUser = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/find-from-user`, data, config)
const GetAllKanbanUsers = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/kanbanUsers/?sort=username,asc&size=500`, data, config)

const AccountRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  UpdatePassword,
  Delete,
  Search,
  ChangeStatus,
  GetAllFromUser,
  GetAllKanbanUsers
}

export default AccountRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/account.js